@if (showUnsavedChangesWarning && validationErrorTemplates?.length == 0) {
  <div>
    <mat-card class="error block">
      <mat-card-title>Unsaved Changes: You are about to leave without saving your changes.</mat-card-title>
    </mat-card>
  </div>
}
@if (validationErrorTemplates?.length > 0) {
  <div>
    @if (validationErrorTemplates?.length == 1) {
      <mat-card class="error block">
        <mat-card-title><ng-container *ngTemplateOutlet="validationErrorTemplates[0]"></ng-container></mat-card-title>
      </mat-card>
    }
    @if (validationErrorTemplates?.length > 1) {
      <mat-card class="error block">
        <mat-card-title>
          <div>Correct {{validationErrorTemplates?.length}} errors on this page:</div>
          @for (c of validationErrorTemplates; track c; let i = $index) {
            <div>&bullet;&nbsp;<ng-container *ngTemplateOutlet="c[i]"></ng-container></div>
          }
        </mat-card-title>
      </mat-card>
    }
  </div>
}
<div class="banner">
  <div class="header rightDivider"><ng-content></ng-content></div>
  <div class="mainControls">
    <ng-content select="[buttonsInFront]"></ng-content>
    <button id="saveButton" [disabled]="!isModified || validationErrorTemplates?.length > 0" (click)="onSave()" class="btn-medium-primary">Save</button>
    <ng-content select="[buttonsInMiddle]"></ng-content>
    @if (showUnsavedChangesWarning) {
      <button  (click)="closeWithoutSave()" class="btn-medium-secondary">Proceed without saving</button>
    }
    <ng-content select="[buttonsInEnd]"></ng-content>
  </div>
  @if (showExpandControls) {
    <div class="expandControls expandControls-settings">
      @if (iss.expandedPanels.length < iss.maxPanels) {
        <a id="expandAllActive" (click)="accordian?.openAll()">Expand All</a>
      }
      @if (iss.expandedPanels.length == iss.maxPanels) {
        <span id="expandAllInactive">Expand All</span>
      }
      &nbsp;/&nbsp;
      @if (iss.expandedPanels.length > 0) {
        <a id="collapseAllActive" (click)="accordian?.closeAll()">Collapse All</a>
      }
      @if (iss.expandedPanels.length == 0) {
        <span id="collapseAllInactive">Collapse All</span>
      }
    </div>
  }
  <br class="clear"/>
</div>
